import { render, staticRenderFns } from "./PageCoverDisplay.vue?vue&type=template&id=e14ca970"
import script from "./PageCoverDisplay.vue?vue&type=script&lang=js"
export * from "./PageCoverDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports